import { render, staticRenderFns } from "./mQuillEditor.vue?vue&type=template&id=97e7f024&scoped=true"
import script from "./mQuillEditor.vue?vue&type=script&lang=js"
export * from "./mQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./mQuillEditor.vue?vue&type=style&index=0&id=97e7f024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e7f024",
  null
  
)

export default component.exports